
function MainScreen({ children, title }) {

  return (
    <div className="containerVisite" style={{ marginTop: "124px"}}>
      <div className="page">
        {title && (
          <>
            <h1 className="heading">{title}</h1>
            <hr />
          </>
        )}
        {children}
      </div>
    </div>
  );
}

export default MainScreen;
